import visiblePanel from 'modules/visiblePanel';
import locale from './localeReducer';

const coreReducers = {
    locale,
    visiblePanel,
};

export default coreReducers;
